export default "__VITE_ASSET__COzHdOWL__"